"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderList = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../../context");

var _utils = require("../../utils");

var _core = require("@emotion/core");

var Ul = (0, _context.styledWithTheme)('ul')({
  listStyleType: 'none',
  margin: 0,
  padding: 0,
  display: 'flex'
});
var Li = (0, _context.styledWithTheme)('li')({
  display: 'flex'
});

var PageHeaderListWithoutDocs = function PageHeaderListWithoutDocs(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      dataTestId = _ref.dataTestId;
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilPageHeaderList',
    dataTestId: dataTestId
  });
  return (0, _core.jsx)(Ul, (0, _extends2.default)({
    role: "list"
  }, dataTestProps), items.map(function (item, index) {
    return (0, _core.jsx)(Li, {
      key: index
    }, item);
  }));
};

var PageHeaderList = (0, _stencilReactDesc.describe)(PageHeaderListWithoutDocs).description('List element containing page header contents and placing them semantically in a list.');
exports.PageHeaderList = PageHeaderList;
PageHeaderList.propTypes = {
  children: _stencilReactDesc.PropTypes.node.description('Content of the list.'),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
};
PageHeaderList.displayName = 'PageHeaderList';